module.exports = __webpack_public_path__ + "static/images/technology_1_3.6ba7a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology_1_3.png
// module id = VoHO
// module chunks = 8